export const companyList = [
    {
        "companyName": "香港公司：CHERRY&JOHN INTERNATIONAL CO., LTD",
        "companyAddress": "RM 023 9/F KWAI SHING IND BLDG (STAGE 2)42-46 TAI LIN PAI RD KWAI CHUNG NT",
        "companyPhone": "咨询电话：852 56192953",
        "receipt": ""
    },
    {
        "companyName": "西安公司：汉和文化科技（深圳）有限公司西安分公司 ",
        "companyAddress": "中国西安市雁塔区曲江池南路金地湖城大境 2栋1单元101室",
        "companyPhone": "029-89123322",
        "receipt": ""
    },
    {
        "companyName": "中山公司：汉和文化科技（深圳）有限公司中山分公司",
        "companyAddress": "中山市港口镇兴港中路136号四楼之四",
        "companyPhone": "076088512186",
        "introduce": "Sinobus中文由漢和文化科技有限公司創辦,總部位於中國·深圳,在中國·香港、中國·中山、中國·西安、美國·洛杉磯設有分公司。公司專注于為4-16歲海外華裔和K2-P6的港澳台地區學童提供系統、正規、科學的數學培訓服務。",
        "receipt": "../assets/ChatUs/汉和文化科技有限公司中山分公司.png"
    },
    {
        "companyName": "美国公司：IMASTER TECHNOLOGY LLC.",
        "companyAddress": "75 egret, Irvine,California, 92618",
        "companyPhone": "+1 2403026131",
        "introduce": "",
        "receipt": ""
    },
    {
        "companyName": "新加坡公司：NOLIMIT LEARNING PTE.LTD",
        "companyAddress": "260B ANG MO KIO STREET 21#18-153 KEBUN BARU COURT SINGAPORE (562260)",
        "companyPhone": "+65 84294388",
        "introduce": "",
        "receipt": "../assets/ChatUs/新加坡.jpg"
    },
    {
        "companyName": "汉和赛诺文化科技(广州)有限公司",
        "companyAddress": "广州市天河区棠下二社涌边一横巷17号201房",
        "companyPhone": "17391965238",
        "introduce": "",
        "receipt": "../assets/ChatUs/汉和赛诺文化科技(广州)有限公司.png"
    },
    {
        "companyName": "君荣安瑞（深圳）控股有限公司",
        "companyAddress": "深圳市南山区沙河街道文昌街社区华侨城天鹅堡R栋08C",
        "companyPhone": "13419515964",
        "introduce": "",
        "receipt": "../assets/ChatUs/君荣安瑞（深圳）控股有限公司.png"
    },
    {
        "companyName": "中国深圳办公中心|全球总部 汉和文化科技(深圳)有限公司",
        "companyAddress": "中国深圳市南山区沙河街道文昌街社区 香山里花园(二期)2栋1单元2B204",
        "companyPhone": "0755-86083397",
        "introduce": "",
        "receipt": "../assets/ChatUs/深圳收银易.png,../assets/ChatUs/深圳微信.png,../assets/ChatUs/深圳支付宝.png"
    }
]